import React, { useState } from "react";
import emailjs from 'emailjs-com';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    number: "",
    email: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    emailjs
      .send(
        "service_w0y4uqi", // Replace with your actual EmailJS service ID
        "template_8lnxjiz", // Replace with your EmailJS template ID
        formData,
        "nVMndy3q-jQjrcEiu" // Replace with your EmailJS public key
      )
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          setSuccessMessage("Your message has been sent successfully!");
          setErrorMessage("");
          setFormData({ name: "", number: "", email: "", message: "" });
        },
        (err) => {
          console.error("FAILED...", err);
          setErrorMessage("Failed to send message. Please try again.");
          setSuccessMessage("");
        }
      )
      .finally(() => setIsSubmitting(false));
  };

  return (
    <div className="text-white px-6">
      <form
        onSubmit={handleSubmit}
        className="max-w-2xl mx-auto bg-gray-800 p-8 rounded-md shadow-lg"
      >
        <div className="mb-4">
          <label className="block text-sm mb-2" htmlFor="name">
            Name
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="w-full p-2 border border-gray-700 rounded-md bg-gray-700 text-white"
            placeholder="Your Name"
            required
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm mb-2" htmlFor="number">
              Number
            </label>
            <input
              type="text"
              id="number"
              name="number"
              value={formData.number}
              onChange={handleChange}
              className="w-full p-2 border border-gray-700 rounded-md bg-gray-700 text-white"
              placeholder="Your Phone Number"
              required
            />
          </div>
          <div>
            <label className="block text-sm mb-2" htmlFor="email">
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full p-2 border border-gray-700 rounded-md bg-gray-700 text-white"
              placeholder="Your Email"
              required
            />
          </div>
        </div>

        <div className="mt-4">
          <label className="block text-sm mb-2" htmlFor="message">
            Message
          </label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            className="w-full p-2 border border-gray-700 rounded-md bg-gray-700 text-white"
            placeholder="Your Message"
            rows="2"
            required
          ></textarea>
        </div>

        {successMessage && (
          <p className="text-green-400 text-sm mt-2">{successMessage}</p>
        )}
        {errorMessage && (
          <p className="text-red-400 text-sm mt-2">{errorMessage}</p>
        )}

        <button
          type="submit"
          className="w-fit font-semibold mt-6 px-8 py-3 bg-gradient-to-r from-blue-500 to-teal-400 text-white rounded-full shadow-md hover:shadow-lg transform hover:scale-105 transition-all"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Sending..." : "Send Message"}
        </button>
      </form>
    </div>
  );
};

export default ContactSection;
